module.exports = __webpack_public_path__ + "static/media/PreWrittenCodeIcon.5c395860.svg";